import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import DepartmentDetailsMain from "./DepartmentDetailsMain";
import Footer from "../../components/Footer";

const DepartmentDetails = () => {
  return (
    <>
      <HeaderFour />
      <DepartmentDetailsMain />
      <Footer />
    </>
  );
};

export default DepartmentDetails;
